<template>
    <ShowTemplate
        :model="learning"
        :owners="[learning.organization].filter((owner) => owner != null)"
        :descriptionTabs="descriptionTabs"
        :can="permissions"
        :access="learning.access"
        :rolePanels="rolePanels"
        :availableEmotions="availableEmotions"
        :relations="relations"
        :sidebarRelations="organizationRelations"
        :statistics="statistics"
    >
        <template #AfterRoleSlot="{ collapsable }">
            <CollapsibleSection
                :name="$lang.get('Chapters')"
                :collapsable="collapsable"
                v-if="showLearnings"
            >
                <template v-slot:default>
                    <div
                        class="space-y-2 py-3 border-b border-border-darker/40"
                    >
                        <div
                            class=""
                            v-for="childOrSibling in learnings"
                            :key="childOrSibling.id"
                        >
                            <div class="flex gap-x-1 items-center">
                                <PhDotOutline class="size-4" weight="bold" />
                                <div
                                    class="font-header truncate text-sm"
                                    :class="{
                                        'font-bold':
                                            childOrSibling.is_current_learning,
                                        'font-normal':
                                            !childOrSibling.is_current_learning,
                                    }"
                                >
                                    <Link
                                        class="underline-hover"
                                        v-if="
                                            !childOrSibling.is_current_learning
                                        "
                                        :href="
                                            $getModelUrl({
                                                modelClass: 'learning',
                                                id: childOrSibling.id,
                                            })
                                        "
                                        v-text="childOrSibling.name"
                                    />
                                    <p
                                        v-if="
                                            childOrSibling.is_current_learning
                                        "
                                        v-text="childOrSibling.name"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </CollapsibleSection>
        </template>
    </ShowTemplate>
</template>

<script>
import ShowTemplate from '@/Templates/ShowTemplate.vue'
import { PhDotOutline } from '@phosphor-icons/vue'
import CollapsibleSection from '@/Components/Utilities/CollapsibleSection.vue'
import { Link } from '@inertiajs/vue3'

export default {
    components: {
        CollapsibleSection,
        Link,
        ShowTemplate,
        PhDotOutline,
    },

    props: {
        learning: {
            type: Object,
            required: true,
        },
        permissions: {
            type: Object,
            required: true,
        },
        rolePanels: {
            type: Array,
            required: true,
        },
        availableEmotions: {
            type: Array,
            required: true,
        },
        resources: {
            type: Object,
            default: {},
        },
        organizations: {
            type: Object,
            default: {},
        },
        events: {
            type: Object,
            default: {},
        },
        statistics: {
            type: Object,
            default: {},
        },
    },

    computed: {
        descriptionTabs() {
            return [
                {
                    id: 'description',
                    name: this.$lang.get('Description'),
                    content: this.learning.description,
                },
                {
                    id: 'objectives',
                    name: this.$lang.get('Objectives'),
                    content: this.learning.objectives,
                },
                {
                    id: 'prerequisites',
                    name: this.$lang.get('Prerequisites'),
                    content: this.learning.prerequisites,
                },
            ].filter((tab) => !!tab.content)
        },

        relations() {
            return [this.resources, this.organizations, this.events].filter(
                (relation) => Object.keys(relation).length > 0
            )
        },

        organizationRelations() {
            return [this.organizations].filter(
                (relation) => Object.keys(relation).length > 0
            )
        },

        learnings() {
            if (this.learning?.learnings?.length > 0) {
                return this.learning.learnings
            } else if (this.learning?.siblingLearnings?.length > 0) {
                return this.learning.siblingLearnings
            }
            return []
        },

        showLearnings() {
            return this.learnings.length > 0
        },

        learningsText() {
            return this.learning?.learnings?.length > 0
                ? this.$lang.get('Learnings')
                : this.$lang.get('Siblings')
        },
    },
}
</script>
